import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { layout, media } from '@prisjakt/ui-base';

const { borderRadius } = layout;

export const Inner = styled.div`
  position: relative;
  padding: 25px;
  border-radius: ${borderRadius};
`;

export const Section = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 20px;

    ${media.largeUp`
      margin-bottom: 0;
      padding-right: 40px;
      margin-right: 40px;
      border-right: 1px solid #bbb;
    `};
  }
`;

export const HelperText = styled.span`
  font-size: 1.4rem;
  font-weight: ${ifProp('bold', 'bold', 'normal')};
  color: ${ifProp('error', 'red', 'inherit')};
`;

export const Title = styled.div`
  font-size: 1.4rem;
  font-weight: bold;
  text-align: left;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  font-weight: bold;
`;

export const Description = styled.div`
  font-size: 1rem;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;

  ${media.mediumDown`
      flex-direction: column;
  `} .pj-ui-radio {
    font-size: 1rem;
    margin-bottom: 5px;

    label {
      white-space: nowrap;
    }
  }

  .pj-ui-text-input {
    margin-bottom: 10px;

    label {
      display: block;
      width: 100%;
      text-align: left;
      font-weight: bold;
      font-size: 16px;
      padding-bottom: 10px;
    }
  }
`;
